/**
 * Format a sequence step's `delayMinutes` for the read surface.
 *
 * Care-plan sequences fire at `scheduled_date + delayMinutes`, so a positive
 * delay reads as "Nh after", a negative delay as "Nh before", and 0 reads as
 * "At scheduled time".
 */
export function formatDelay(minutes: number): string {
  if (minutes === 0) return "At scheduled time";
  return `${formatDuration(Math.abs(minutes))} ${minutes < 0 ? "before" : "after"}`;
}

/**
 * Full sentence describing when a sequence will fire — used in the editor
 * to give live feedback as the user changes the delay.
 */
export function describeDelay(minutes: number): string {
  if (minutes === 0) return "Will be sent at scheduled time";
  const direction = minutes < 0 ? "before" : "after";
  return `Will be sent ${formatDuration(Math.abs(minutes))} ${direction} scheduled time`;
}

function formatDuration(minutes: number): string {
  if (minutes >= 1440 && minutes % 1440 === 0) {
    const days = minutes / 1440;
    return `${days} day${days === 1 ? "" : "s"}`;
  }
  if (minutes >= 60 && minutes % 60 === 0) {
    const hours = minutes / 60;
    return `${hours} hr${hours === 1 ? "" : "s"}`;
  }
  return `${minutes} min`;
}
